import "../css/Plan.css";
import { useNavigate } from "react-router-dom";
import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import { apiClient } from "../apiClient";
import colors from '../colors';

function Plan(props)
{

    const navigate = useNavigate();
    const online = JSON.parse(localStorage.getItem('seo_app')) != null ? true : false;
    const user = localStorage.getItem('seo_app')? JSON.parse(localStorage.getItem('seo_app')): { name: "" };
    const token = JSON.parse(localStorage.getItem('userToken'));
    const config = {  headers: {"Content-Type": "application/json",Authorization: `Bearer ${token}`} };
    const toast = useRef(null);
    const [selectedPlan,setSelectedPlan] = useState("");
    const [updatePlans,setUpdatePlans] = useState(0);


    //get selected plan:
    useEffect(() =>
        {
            if(online)
                apiClient.get(process.env.REACT_APP_BACK + "/users/getUserPlan/" + user._id, config)
              .then((response) => {
                  setSelectedPlan(response.data.toString());
              })
              .catch((error) => {
                
              });
        },[updatePlans]);

    //save plan in user record:
    const selectPlan = (plan) =>{

        //if user is not online, redirect to login page:
        if(!online)
            navigate("/login");
        else
        {

            
            const data = { plan: plan };
            apiClient.patch(process.env.REACT_APP_BACK + "/users/updatePlan/" + user._id,data, config)
              .then((response) => {
                  toast.current.show({severity: 'success', summary:"پلن "+ plan+" برای شما فعال شد" }); 
                  setUpdatePlans(updatePlans+1);
                  
              })
              .catch((error) => {
                console.log("error",error);
                
              });

        }


    }

    return(
        
            <div id="plan">

            <Toast ref={toast} position="center"></Toast>
        
            {props.type==="free" && (

                <div className="plan-box" >
                    <img className="pi pi-images" src={require("../images/plan3.png")} alt={process.env.REACT_APP_ALT}></img>
                    <div style={{height:"80px"}}>
                        <h3 className="title">نردبون (رایگان)</h3>
                    </div>

                    <div className="information-box">

                    <span className="line">
                        <i className="pi-check pi"></i>
                        <span className="subtitle">تحویل 3 مقاله سئو شده در آخر هفته</span>
                    </span>

                    <span className="line">
                        <i className="pi-check pi"></i>
                        <span className="subtitle">درج تصاویر و لینک های خارجی</span>
                    </span>

                    <span className="line">
                        <i className="pi-check pi"></i>
                        <span className="subtitle">امکان درج واترمارک روی تصاویر</span>
                    </span>

                    <span className="line">
                        <i className="pi-check pi"></i>
                        <span className="subtitle">پیشنهاد کلمه کلیدی های فرعی</span>
                    </span>

                    <span className="line">
                        <i className="pi-check pi"></i>
                        <span className="subtitle">امکان لینک سازی داخلی</span>
                    </span>

                    <span className="line">
                        <i className="pi-check pi"></i>
                        <span className="subtitle">آپدیت هفتگی رتبه مقاله در سرچ گوگل</span>
                    </span>

                    </div>

                    <button 
            className={selectedPlan !== "رایگان" ? "plan-button" : "selected-plan"}
            onClick={ () => selectPlan("رایگان")}
            disabled={selectedPlan ==="رایگان" ? true : false}
            >
                {selectedPlan === "رایگان" ?
                "این پلن برای شما فعال است" 
                :"انتخاب کنید" 
                }
               </button>

                </div>
            )}
        

        {props.type==="rocket" && (
                <div className="plan-box" >
                <img className="pi pi-images" src={require("../images/plan1.png")} alt={process.env.REACT_APP_ALT}></img>
                <div style={{height:"80px"}}>
                    <h3 className="title">هواپیما</h3>
                    <h6 className="comingsoon">به زودی</h6>
                </div>

                <div className="information-box">

                <span className="line">
                        <i className="pi-check pi"></i>
                        <span className="subtitle">تحویل  </span>
                        <span className="emphasize"> آنی  </span>
                        <span className="subtitle"> 5 مقاله سئو شده </span>
                    </span>

                    <span className="line">
                        <i className="pi-check pi"></i>
                        <span className="subtitle">درج تصاویر و لینک های خارجی</span>
                    </span>

                    <span className="line">
                        <i className="pi-check pi"></i>
                        <span className="subtitle">امکان درج واترمارک روی تصاویر</span>
                    </span>

                    <span className="line">
                        <i className="pi-check pi"></i>
                        <span className="subtitle">پیشنهاد کلمه کلیدی های فرعی</span>
                    </span>

                    <span className="line">
                        <i className="pi-check pi"></i>
                        <span className="subtitle">امکان لینک سازی داخلی</span>
                    </span>

                    <span className="line">
                        <i className="pi-check pi"></i>
                        <span className="subtitle">آپدیت</span>
                        <span className="emphasize">روزانه</span>
                        <span className="subtitle">رتبه مقاله در سرچ گوگل</span>
                    </span>

                    <span className="line">
                        <i className="pi-check pi"></i>
                        <span className="emphasize">انتشار خودکار مقاله ها (در سایتهای وردپرسی)</span>
                    </span>
                    
                    </div>

                    <button 
        
            className="plan-button coming-soon"
            onClick={ () => selectPlan("موشک")}
            disabled={true}
            >
                به زودی</button>
                
            </div>
        )}

            
            
        {props.type==="airplane" && (

            <div className="plan-box" 
              // onClick={() => {navigate();}}
              >
                <img className="pi pi-images" src={require("../images/plan2.png")} alt={process.env.REACT_APP_ALT}></img>
                <div style={{height:"80px"}}>
                    <h3 className="title">موشک</h3>
                    <h6 className="comingsoon">به زودی</h6>
                </div>

                <div className="information-box">

                <span className="line">
                        <i className="pi-check pi"></i>
                        <span className="subtitle">تحویل  </span>
                        <span className="emphasize">  آنی  </span>
                        <span className="subtitle"> 7 مقاله سئو شده </span>
                    </span>

                    <span className="line">
                        <i className="pi-check pi"></i>
                        <span className="subtitle">درج تصاویر و لینک های خارجی</span>
                    </span>

                    <span className="line">
                        <i className="pi-check pi"></i>
                        <span className="subtitle">امکان درج واترمارک روی تصاویر</span>
                    </span>

                    <span className="line">
                        <i className="pi-check pi"></i>
                        <span className="subtitle">پیشنهاد کلمه کلیدی های فرعی</span>
                    </span>

                    <span className="line">
                        <i className="pi-check pi"></i>
                        <span className="subtitle">امکان لینک سازی داخلی</span>
                    </span>

                    <span className="line">
                        <i className="pi-check pi"></i>
                        <span className="subtitle">آپدیت</span>
                        <span className="emphasize">روزانه</span>
                        <span className="subtitle">رتبه مقاله در سرچ گوگل</span>
                    </span>

                    <span className="line">
                        <i className="pi-check pi"></i>
                        <span className="emphasize">تولید تصاویر یکتا با هوش مصنوعی</span>
                    </span>

                    <span className="line">
                        <i className="pi-check pi"></i>
                        <span className="emphasize">انتشار خودکار مقاله ها (در سایتهای وردپرسی)</span>
                    </span>

                    </div>

                    <button 
                    className="plan-button coming-soon"
                    onClick={() => selectPlan("هواپیما")}
                    disabled={true}
                    >
                     به زودی</button>
                
                </div>
        )}

            
            
       




        </div>
    );

}

export default Plan;